const IPV4 =
  /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
const IPV6_GROUP = '[0-9a-f]{1,4}';
const IPV6 = new RegExp(
  `^(` +
    `(${IPV6_GROUP}:){7}${IPV6_GROUP}|` +
    `(${IPV6_GROUP}:){1,7}:|` +
    `(${IPV6_GROUP}:){1,6}:${IPV6_GROUP}|` +
    `(${IPV6_GROUP}:){1,5}(:${IPV6_GROUP}){1,2}|` +
    `(${IPV6_GROUP}:){1,4}(:${IPV6_GROUP}){1,3}|` +
    `(${IPV6_GROUP}:){1,3}(:${IPV6_GROUP}){1,4}|` +
    `(${IPV6_GROUP}:){1,2}(:${IPV6_GROUP}){1,5}|` +
    `${IPV6_GROUP}:(:${IPV6_GROUP}){1,6}|` +
    `:((:${IPV6_GROUP}){1,7}|:)` +
    `)$`,
  'i'
);

export const isValidIpAddress = (value: string): boolean => {
  const trimmed = (value ?? '').trim();
  return IPV4.test(trimmed) || IPV6.test(trimmed);
};
